import {
  FunctionField as RaFunctionField,
  FunctionFieldProps as RaFunctionFieldProps,
} from 'react-admin';

export const FunctionField = RaFunctionField;

export type FunctionFieldProps = RaFunctionFieldProps;
